import type { User } from '~/types';
import type { Recipient } from '../../types';
import { I18n } from '~/common/explicit-exports';

export const getInfoWithTeammateNames = (recipients: Recipient[], limit: number) => {
  const teammates = recipients
    .slice(0, limit)
    .map((recipient) => (Number.isNaN(+recipient.id) ? `<${recipient.displayName}>` : recipient.displayName))
    .join(', ');

  return I18n.t('js.learner.guide.task.ask_a_teammate.info_with_teammates', {
    teammates,
  });
};

export const mapContactToRecipient = ({ id, name, displayName, avatar }: Partial<User>) => ({
  id,
  displayName: displayName || name,
  avatar,
});
